<script setup lang="ts">
import { computed } from 'vue';

import IconFa6SolidImage from '~icons/fa6-solid/image';

interface ModuleHeaderProps {
  module: {
    components: {
      logo: {
        src: string;
      };
    };
  };
}

defineOptions({
  name: 'ModuleHeaderDisplay'
});

const props = withDefaults(defineProps<ModuleHeaderProps>(), {
  module: () => ({
    components: {
      logo: {
        src: '',
      },
    },
  }),
});

const components = computed(() => props.module.components);
const needRender = computed(() => [
  components.value.logo.src,
].some(Boolean));
</script>

<template>
<nav class="module-header-display" v-if="needRender">
  <div class="module-header-display__wrapper">
    <template v-if="components.logo.src">
      <el-image class="w-full h-full" :src="components.logo.src" fit="contain"/>
    </template>
    <template v-else>
      <div class="module-header-display__skeleton">
        <IconFa6SolidImage class="text-white text-3xl"/>
      </div>
    </template>
  </div>
</nav>
</template>
<style lang="scss" scoped>
.module-header-display {
  @apply flex justify-center items-center;
  @apply w-full h-16 px-8 pt-0;
  @apply bg-white border-b border-gray-700;

  // FIXME: 這是為了目前 module gap 是用 padding 實作的 workaround
  // FIXME: 實作上應該用 margin 或 gap，順便處理 background-color 的問題
  + :deep(.module-container) {
    @apply pt-8;
  }

  &__wrapper {
    @apply w-24 h-12;
  }

  &__skeleton {
    @apply flex justify-center items-center;
    @apply bg-gray-600 w-full h-full;
  }
}

// 平板
.tablet .module-header-display {
}

// PC - 1024px
.laptop .module-header-display {
  @apply justify-start;

  + :deep(.module-container) {
    @apply pt-16;
  }

  &:not(.zoom-out) {
    max-width: 100% !important;
  }
}

// PC - 1440px
.desktop .module-header-display {
  @apply justify-start;

  + :deep(.module-container) {
    @apply pt-16;
  }

  &:not(.zoom-out) {
    max-width: 100% !important;
  }
}
</style>
